import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import * as actions from '../actions/secmasteractions'
import NavBar from '../../../components/NavBar';
import SideNav from '../../../components/SideNav';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';
import CustomPager from '../../../components/custompager';
import GroupMenus from '../components/GroupMenus';
import GroupReports from '../components/GroupReports';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
import TopBar from '../../../components/newdashboardcomponent/TopBar';


export default function UserGroup() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { register: registerUserGroupSearch,
        reset: resetUserGroupSearch, handleSubmit: onSubmitData, setValue: setUserGroupSearchValue, watch: watchUserGroupSearch, formState: { errors: errorsUserGroupSearch } } = useForm();

    const { register: registerUserGroupCreation,
        reset: resetUserGroupCreation, handleSubmit: onSubmitUserGroupCreationData, setValue: setUserGroupCreationValue, watch: watchUserGroupCreation, formState: { errors: errorsUserGroupCreation } } = useForm();

    let checkPermissions = state.checkPermissions;
    let modalsState = state.modalsState;
    let userGroup = state.userGroupSearch;
    let userGroupCreate = state.userGroupCreate;
    let masters = state.masters;

    console.log("userGroupSearch", userGroup)
    console.log("userGroupSearchResult", userGroup.searchResult)
    console.log("userGroupCreate", userGroupCreate)
    console.log("modalsState", modalsState)
    const refUserGroup = useRef(null);

    useEffect(() => {
        let valuesToMap = [
            { "userGroupCode": userGroup.userGroupCode },
            { "userGroupName": userGroup.userGroupName },
            { "department": userGroup.department }

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setUserGroupSearchValue(key, i[key])));
    }, [userGroup]);

    useEffect(() => {
        // if (quoteInformation.quotationId) {
        let valuesToMap = [
            { "userGroupId": userGroupCreate.userGroupId },
            { "userGroupCode": userGroupCreate.userGroupCode },
            { "userGroupName": userGroupCreate.userGroupName },
            { "remarks": userGroupCreate.remarks },
            { "designation": userGroupCreate.designation }

        ];
        //console.table(valuesToMap);
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setUserGroupCreationValue(key, i[key])));
        //  }

    }, [userGroupCreate]);

    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageMenuId: 719 }));
            await dispatch(actions.getInsuredInfoMasters(0));
            await dispatch(actions.getSecurityMasters());
            await dispatch(actions.checkSecurityModuleAccess());
        }
        CheckPermissions();
        navigate('');
    }, []);

    const onResetUserGroupSearch = () => {
        resetUserGroupSearch();
        dispatch(actions.clearUserGroupSearchParams());
    }

    const showGroupMenusModal = async () => {
        {
            let name = "showGroupMenusModal";
            let value = true;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        await dispatch(actions.getSystemMenus());
    }
    const showGroupReportsModal = async () => {
        {
            let name = "showGroupReportsModal";
            let value = true;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        await dispatch(actions.getSystemReports());
    }
    const handleUserGroupSearch = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateUserGroupSearchParams({ name, value }));
    }

    const onResetUserGroupCreation = () => {
        navigate('');
        resetUserGroupCreation();
        dispatch(actions.clearUserGroupInformation());
    }
    const onAddNewUserGroup = async () => {
        onResetUserGroupCreation();
        dispatch(actions.showCurrentUserGroup(true));
        dispatch(actions.showUserGroup(true));
        dispatch(actions.collapseUserGroupSearchResults(true));
        dispatch(actions.collapseUserGroupSearch(true));
        {
            let name = "showGroupMenusModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        {
            let name = "showGroupReportsModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        scrollToBottom();
    }
    const scrollToBottom = () => {
        refUserGroup.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const handleUserGroupCreation = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateUserGroupCreationParams({ name, value }));
    }

    const onError = (errorsUserGroupSearch, e) => console.log(errorsUserGroupSearch, e);

    const onCollapseUserSearch = () => {
        if (userGroup.searchClass === "collapse show") {
            dispatch(actions.collapseUserGroupSearch(true));
        } else {
            dispatch(actions.collapseUserGroupSearch(false));
        }
    }
    const onCollapseUserGroupSearchResult = () => {
        if (userGroup.searchClass === "collapse show") {
            dispatch(actions.collapseUserGroupSearchResults(true));
        } else {
            dispatch(actions.collapseUserGroupSearchResults(false));
        }
    }


    const onUserGroupSearchSubmit = async (data, e) => {
        navigate('');
        await dispatch(actions.getUserGroupSearchResults(1));
    }
    const updateSortString = async (val) => {
        await dispatch(actions.getUserGroupSortResults(val));
    }

    const onPageChangeRequest = async (page) => {
        await dispatch(actions.getUserGroupSearchResults(page))
    }

    const onDisplayGroup = async (groupName, groupId) => {

        dispatch(actions.updateCurrentGroupId(groupId));
        dispatch(actions.showCurrentUserGroup(true));
        dispatch(actions.showUserGroup(true));
        await dispatch(actions.getGroupInfo(groupId));
        dispatch(actions.collapseUserGroupSearch(true));
        dispatch(actions.collapseUserGroupSearchResults(true));
        {
            let name = "showGroupMenusModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        {
            let name = "showGroupReportsModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        scrollToBottom();
    }

    const onUserGroupSubmit = async (data, e) => {
        let currentGroupName = await dispatch(actions.saveUserGroupInfo());
        navigate('?group=' + currentGroupName);


    }
    function renderSearchCriteria() {


        let UserGroupCode = <input className={errorsUserGroupSearch.userGroupCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="userGroupCode" required=""
            placeholder="--Group Code--"
            name='userGroupCode'
            {...registerUserGroupSearch("userGroupCode", { onChange: (value) => handleUserGroupSearch(value) })}
            value={userGroup.userGroupCode}
        />

        let UserGroupName = <select className="form-select fw-bold" data-toggle="select2" id="userGroupName" name="userGroupName"
            {...registerUserGroupSearch("userGroupName", { onChange: (e) => handleUserGroupSearch(e) })}
            value={userGroup.userGroupName}
        >
            <option value="">--Group Name--</option>
            {masters.userGroupMasters.map((userGroupMasters, index) => (
                <option value={userGroupMasters.groupId} key={userGroupMasters.groupId}>
                    {userGroupMasters.groupName}
                </option>
            ))}
        </select>

        let Department = <select className="form-select fw-bold" data-toggle="select2" id="department" name="department"
            {...registerUserGroupSearch("department", { onChange: (e) => handleUserGroupSearch(e) })}
            value={userGroup.department}
        >
            <option value="">--Department--</option>
            {masters.departmentMasters.map((departmentMasters, index) => (
                <option value={departmentMasters.domainValue} key={departmentMasters.domainValue}>
                    {departmentMasters.domainValueName}
                </option>
            ))}
        </select>

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={onSubmitData(onUserGroupSearchSubmit, onError)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetGroupSearch && <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetUserGroupSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-1"></div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Code </label>
                            {UserGroupCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Name </label>
                            {UserGroupName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Department </label>
                            {Department}
                        </div>
                    </div>
                    <div className="row g-2">
                        <div id="tooltip-container2">
                            {checkPermissions.hasSearchGroup && <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                            }
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">

                        </div>
                    </div>





                </form>

            </>

        )
    }

    function renderUserGroupListing() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div className={userGroup.searchResultClass} id="CollapseSearchResult">
                    <div className="row g-2">
                        <div className="mb-1 col-md-6">
                            {!userGroup.showSearchResult && <h5 className="alert alert-danger">No Records Found...</h5>}
                        </div>
                    </div>
                    {userGroup.showSearchResult &&
                        <>
                            <div className="table-responsive">
                                <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                                    <thead>

                                        <tr>
                                            <th>Actions  ⬇️</th>
                                            <th onClick={() => updateSortString('UserGroupCode')}>User Group Code  ⬇️</th>
                                            <th onClick={() => updateSortString('UserGroupName')}>User Group Name  ⬇️</th>
                                            {/* <th onClick={() => updateSortString('ActiveYN')}>Active Y/N  ⬇️</th> */}

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {userGroup.searchResult.result.map((searchResult, index) => (

                                            <tr >
                                                <td>
                                                    {checkPermissions.hasViewGroup && <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" onClick={() => onDisplayGroup(searchResult.userGroupName, searchResult.groupId)}>
                                                        <i className="dripicons-preview"></i>
                                                    </button>
                                                    }
                                                </td>
                                                <td> {searchResult.userGroupCode} </td>
                                                <td> {searchResult.userGroupName} </td>
                                                {/* <td> <input type="checkbox" id={searchResult.rNo} className="form-check-input"
                                                    checked={searchResult.activeYN}
                                                    disabled={true}
                                                    value={searchResult.rNo} />
                                                </td> */}
                                            </tr>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="float-end">
                                <CustomPager onPageChangeRequest={onPageChangeRequest} pagedResult={userGroup.searchResult} />
                            </div>
                        </>
                    }
                </div>
            </>
        )
    }

    function renderUserGroupCreation() {

        let UserGroupCode = <input className={errorsUserGroupCreation.userGroupCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="userGroupCode" required=""
            placeholder="--User Group Code--"
            name='userGroupCode'
            {...registerUserGroupCreation("userGroupCode", { onChange: (e) => handleUserGroupCreation(e) })}
            value={userGroupCreate.userGroupCode}
        />

        let UserGroupName = <input className="form-control fw-bold"
            placeholder="--User Group Name--"
            id="userGroupName"
            name="userGroupName"
            {...registerUserGroupCreation("userGroupName", { onChange: (e) => handleUserGroupCreation(e) })}
            value={userGroupCreate.userGroupName}
        />

        let Remarks = <input className="form-control fw-bold"
            placeholder="--Remarks--"
            id="remarks"
            name="remarks"
            {...registerUserGroupCreation("remarks", { onChange: (e) => handleUserGroupCreation(e) })}
            value={userGroupCreate.remarks}
        />

        let Department = <select className="form-select fw-bold" data-toggle="select2" id="department" name="department"
            {...registerUserGroupCreation("department", { onChange: (e) => handleUserGroupCreation(e) })}
            value={userGroupCreate.department}
        >
            <option value="">--Department--</option>
            {masters.departmentMasters.map((departmentMasters, index) => (
                <option value={departmentMasters.domainValue} key={departmentMasters.domainValue}>
                    {departmentMasters.domainValueName}
                </option>
            ))}
        </select>

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation collapse show" id="CollapseUserGroupCreate"
                    onSubmit={onSubmitUserGroupCreationData(onUserGroupSubmit, onError)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetGroup && <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetUserGroupCreation()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Group Code </label>
                            {UserGroupCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Group Name </label>
                            {UserGroupName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Remarks </label>
                            {Remarks}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Department </label>
                            {Department}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3"></div>
                        <div className="mb-3 col-md-3">
                            <div id="tooltip-container2">
                                {checkPermissions.hasSaveGroup && <button type="submit" className="btn btn-success float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save"></i> Save   </button>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <div id="tooltip-container2">
                                {userGroupCreate.groupId != null &&
                                    <>
                                        {checkPermissions.hasGroupMenus && <button type="button" className="btn btn-primary float-start"
                                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="ApplicationBranch" onClick={() => showGroupMenusModal()}> Group Menus</button>
                                        }
                                        {checkPermissions.hasGroupReports && <button type="button" className="btn btn-success float-start"
                                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="ApplicationBranch" onClick={() => showGroupReportsModal()}> Group Reports</button>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                </form>

            </>
        )
    }


    return (

        <>
            <div className="wrapper">
                <LeftSideMenu />
                <div class="content-page">
                    <TopBar />
                    <div class="content">

                        <DashboardTitle />
                        <div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>User Group</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">
                                                {checkPermissions.hasAddNewGroup &&
                                                    <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New User" onClick={() => onAddNewUserGroup()}>
                                                        <i className="dripicons-plus"></i> New User Group
                                                    </button>
                                                }
                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseUserSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {userGroup.isSubmit &&
                            <div className="content">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card ribbon-box">
                                            <div className="card-body">
                                                <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>User Group Listing</div>
                                                <div className="btn-group float-end" id="tooltip-container2">
                                                    <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchresultscollapsableButton"
                                                        data-bs-toggle="collapse" data-bs-target="#CollapseSearchResult"
                                                        aria-expanded="false" aria-controls="CollapseSearchResult" onClick={() => onCollapseUserGroupSearchResult()}>
                                                        <i className="mdi mdi-arrow-up-down"></i>
                                                    </button>
                                                </div>
                                                <h5 className="text-primary float-end mt-0"> </h5>
                                                <div className="ribbon-content">
                                                    {renderUserGroupListing()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {userGroupCreate.showUserGroup &&
                            <div className="content" ref={refUserGroup}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card ribbon-box">
                                            <div className="card-body">
                                                <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>User Group Creation</div>
                                                <div className="btn-group float-end" id="tooltip-container2">
                                                    <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                        data-bs-toggle="collapse" data-bs-target="#CollapseUserGroupCreate"
                                                        aria-expanded="false" aria-controls="CollapseUserGroupCreate">
                                                        <i className="mdi mdi-arrow-up-down"></i>
                                                    </button>
                                                </div>
                                                <h5 className="text-primary float-end mt-0"> </h5>
                                                <div className="ribbon-content">
                                                    {renderUserGroupCreation()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row">
                            {modalsState.showGroupMenusModal &&
                                <div className="col-6">

                                    <GroupMenus />
                                </div>
                            }
                            {modalsState.showGroupReportsModal &&
                                <div className="col-6">
                                    <GroupReports />
                                </div>
                            }
                        </div>
                    </div>
                    <Footer />
                </div>


            </div>

        </>
    )
}